import ParentInfoPage from "components/organisms/schools/parentInfo"

export default ParentInfoPage
